import { render, staticRenderFns } from "./Home_page.vue?vue&type=template&id=8b0af10a&scoped=true"
import script from "./Home_page.vue?vue&type=script&lang=js"
export * from "./Home_page.vue?vue&type=script&lang=js"
import style0 from "./Home_page.vue?vue&type=style&index=0&id=8b0af10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0af10a",
  null
  
)

export default component.exports